module.exports = __webpack_public_path__ + "img/hero.63cf70a0.jpeg";